import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { playerPositionsOptionsAtom } from '@/atoms/queries/player/playerPositions';
import { PositionOption } from '@/types/filters';
import { Position } from '@/types/player';
import { SectionAtomMap } from '@/types/section';
import { convertFiltersToOption } from '@/utils/array';
import { getAtomForSection } from '@/utils/atoms/section';
import { filtersAtom } from '../filter';

/* list of all positions as required by the data locker pitch position selector */
const dataLockerPositionsOptionsAtom = atom(async () => convertFiltersToOption(Object.values(Position)));

const positionSectionMapAtom = atom<SectionAtomMap<PositionOption[]>>(() => ({
  player: playerPositionsOptionsAtom,
  dataLocker: dataLockerPositionsOptionsAtom,
}));

export const positionOptionsAtom = atom(getAtomForSection(positionSectionMapAtom));

export const selectedPositionsFilterParamsAtom = atom(get => get(filtersAtom).positions.flatMap(id => id.split(',')));

const unwrappedPositionOptions = unwrap(positionOptionsAtom, prev => prev || []);

export const selectedPositionOptionsAtom = atom(get => {
  const positionOptions = get(unwrappedPositionOptions);
  const selectedPositions = get(filtersAtom).positions;

  return positionOptions.filter(({ value }) => selectedPositions.some(position => position === value));
});

export const unwrappedSelectedPositionOptionsAtom = unwrap(selectedPositionOptionsAtom, prev => prev || []);
